import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { isDevelopmentMode } from '@/shared/helpers/environmentHelper';
import { authApi } from '@/shared/modules/auth/business';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from './baseApi';
import { customerReducer } from './modules/customers/business';
import { orderReducer } from './modules/orders/business';
import { priceListReducer } from './modules/priceLists/business';
import { customerDebtReportReducer } from './modules/reports/customers/business';
import { supplierDebtReportReducer } from './modules/reports/suppliers/business';
import { driverStateReducer } from './modules/settings/drivers/business';
import { identityStateReducer } from './modules/settings/identity/business';
import { locationStateReducer } from './modules/settings/locations/business';
import { storageStateReducer } from './modules/settings/storage/business';
import { warehousesStateReducer } from './modules/settings/warehouses/business';
import { stockStateReducer } from './modules/stock/business';
import { stockReceiptStateReducer } from './modules/stockReceipt/business';
import { supplierReducer } from './modules/suppliers/business';
const rootReducer = combineReducers({
    customers: customerReducer,
    orders: orderReducer,
    suppliers: supplierReducer,
    priceLists: priceListReducer,
    stockReceipt: stockReceiptStateReducer,
    stock: stockStateReducer,
    identity: identityStateReducer,
    warehouses: warehousesStateReducer,
    storage: storageStateReducer,
    locations: locationStateReducer,
    drivers: driverStateReducer,
    customerDebtReport: customerDebtReportReducer,
    supplierDebtReport: supplierDebtReportReducer,
    [authApi.reducerPath]: authApi.reducer,
    [baseApi.reducerPath]: baseApi.reducer,
});
export const store = configureStore({
    reducer: rootReducer,
    devTools: isDevelopmentMode(),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(authApi.middleware, baseApi.middleware),
});
setupListeners(store.dispatch);
